module.exports = __webpack_public_path__ + "static/media/Hybrid_BarleyGreen.28daaf4e.svg";